<cc-footnote-hint
  [hint]="footnoteHint"
  [component]="component"
  [class.cc-footnote-hint--is-not-interactive]="isNotInteractive"
/>
